import Vue from "vue";
import SNACKBAR_TYPES from "../../../utils/enum/SNACKBAR_TYPES";

import i18n from "../../../language/i18n";

const DEFAULT_TYPE = SNACKBAR_TYPES.INFO;
const SECONDS_4 = 4000; // in ms

const DEFAULT_MESSAGE = type => {
    switch(type) {
        case SNACKBAR_TYPES.SUCCESS:
            return i18n.t('SnackBar.message.success');
        case SNACKBAR_TYPES.ERROR:
            return i18n.t('SnackBar.message.error');
        default:
            return i18n.t('SnackBar.message.info');
    }
}

export default {
    namespaced: true,
    state: {
        isVisible: false,
        type: DEFAULT_TYPE,
        message: DEFAULT_MESSAGE,
    },
    mutations: {
        setSnackbarMessage(state, message) {
            Vue.set(state, 'message', message);
        },
        showSnackbar(state) {
            Vue.set(state, 'isVisible', true);
        },
        hideSnackbar(state) {
            Vue.set(state, 'isVisible', false);
        },
        setSnackbarType(state, type) {
            Vue.set(state, 'type', type);
        },
        resetStore(state) {
            Vue.set(state, 'isVisible', false);
            Vue.set(state, 'type', DEFAULT_TYPE);
            Vue.set(state, 'message', DEFAULT_MESSAGE);
        }
    },
    actions: {
        async showSnackbarWithMessage({ commit }, {type = DEFAULT_TYPE, message = DEFAULT_MESSAGE(type) }) {
            await commit('setSnackbarMessage', message);
            commit('setSnackbarType', type);
            commit('showSnackbar');

            setTimeout(function() {
                commit('hideSnackbar');
            }, SECONDS_4);
        },
        closeSnackbar({ commit }) {
            commit('hideSnackbar');
        },
        resetStore({ commit }) {
            commit('resetStore');
        }
    },
    getters: {
        snackBarVisibilityState: state => {
            return state.isVisible;
        },
        snackBarMessage: state => {
            return state.message;
        },
        snackBarType: state => {
            return state.type;
        }
    }
}
